<script lang="ts" setup>
import MCommunicationRecipientInput from "./MCommunicationRecipientInput.vue";

const defaultOptions = [
  {
    value: {
      recipientId: "019a4ebf-2dd3-70e4-b12d-5c515b9cbe44",
      recipientType: "patient",
      newCommunicationId: "019bb740-13e0-70ab-9fd0-1ced19f74a48",
      defaultChannelOverride: null,
      adhocEmailAddress: null,
      adhocTelephoneNumberForSMS: null,
    },
    label: "Mr Thomas Banks (a@a.com)",
    name: "Mr Thomas Banks",
    defaultChannelValue: "a@a.com",
    emailAddresses: [
      {
        value: "a@a.com",
        label: "a@a.com",
      },
      {
        value: "marek.billington@medicus.health",
        label: "marek.billington@medicus.health",
      },
    ],
    telephoneNumbers: [
      {
        value: "07389 112725",
        label: "07389 112725 (preferred for SMS)",
      },
      {
        value: "07389 112726",
        label: "07389 112726",
      },
    ],
    recipientHasViableChannel: true,
    filteredAvailableCommunicationChannelOptions: [
      {
        value: "email",
        label: "Email",
        shortLabel: "Email",
        isSMSMessage: false,
        isEmail: true,
        isTelephoneCall: false,
        isInPersonConversation: false,
        isLetter: false,
        isOnlineMessage: false,
        formattedLabel: "Email (a@a.com)",
      },
      {
        value: "sms-message",
        label: "Text message",
        shortLabel: "Text",
        isSMSMessage: true,
        isEmail: false,
        isTelephoneCall: false,
        isInPersonConversation: false,
        isLetter: false,
        isOnlineMessage: false,
        formattedLabel: "Telephone number (07389 112725)",
      },
    ],
    preferredChannelType: "default",
  },
];

const defaultAvailableChannels = [
  {
    value: "email",
    label: "Email",
    shortLabel: "Email",
    isSMSMessage: false,
    isEmail: true,
    isTelephoneCall: false,
    isInPersonConversation: false,
    isLetter: false,
    isOnlineMessage: false,
  },
  {
    value: "sms-message",
    label: "Text message",
    shortLabel: "Text",
    isSMSMessage: true,
    isEmail: false,
    isTelephoneCall: false,
    isInPersonConversation: false,
    isLetter: false,
    isOnlineMessage: false,
  },
];
</script>
<template>
  <!-- Empty recipients and list -->
  <m-communication-recipient-input
    :recipient-options="[]"
    :available-communication-channel-types="[]"
    @recipients-updated="() => true"
  />

  <!-- Default example -->
  <m-communication-recipient-input
    :recipient-options="defaultOptions"
    :available-communication-channel-types="defaultAvailableChannels"
    @recipients-updated="() => true"
  />
</template>
